const parentElem= document.createElement('div')
	, childElem= document.createElement('div');

parentElem.className= "jhc-loading-area";
childElem.className= "jhc-loading-svg";
parentElem.appendChild(childElem);

const jhcLoading= {
	show: ( elem )=> { parentElem.appendChild(childElem); elem.innerHTML= ''; elem.appendChild(parentElem); },
	remove: ( elem )=> { parentElem.parentNode.removeChild(parentElem); },
	appendShow: ( elem )=> { elem.appendChild(parentElem); }
}
export default jhcLoading;